export default __webpack_public_path__ + "2ca3ea299a0f0144292afafb8dde7565.png";